module.exports = __webpack_public_path__ + "images/emoji/heartpulse.6de3ddb0f5b452d23b94.png";